module.exports = __webpack_public_path__ + "images/signal_2.099cc6bb128f9a894540539b11e1cc4b.png";